<template>
  <div id="app" class="app-main">
    <template>
      <template v-if="app.isMobile&&!app.sany">
        <!--<keep-alive :max="2" :exclude="excludeItems">-->
          <router-view></router-view>
        <!--</keep-alive>-->
      </template>
      <template v-else>
        <router-view></router-view>
      </template>
    </template>
  </div>
</template>

<script>
  export default {
    name: 'app',
    beforeCreate() {
      try {
        //去除加载动画
        document.getElementById('appLoading').style.display = "none";
        document.body.removeChild(document.getElementById('appLoading'))
      } catch (e) {
      }
    },
    data() {
      return {
        excludeItems: ['Course', 'Courseware', 'DocDetail', 'BbsDetail', 'Contract', 'GuestCourse', 'GuestCourseware', 'GuestDocDetail', 'Exam', 'Paper', 'PaperRecord', 'Special', 'Train', 'TrainPaper', 'TvLive', 'DocList', "WorkflowNode",'Redirect']
      }
    }
  }

</script>


<style>

  .app-main {
    width: 100%;
    height: 100%;
  }
</style>



// WEBPACK FOOTER //
// App.vue?695c4a47